import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContextToken, HttpErrorResponse, HttpParams, HttpContext } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '@/environments/environment';
// import { authInterceptor } from '../interceptors/auth.interceptor';

export interface ErrorMessageType {
  message: string;
  type: 400 | 401 | 403 | 404 | 500 | 'default';
}
export interface HttpInterceptorConfig {
  shouldShowSucceessToaster?: boolean, 
  successToasterMessage?: string, 
  shouldShowErrorToaster?: boolean, 
  errorToasterMessage?: ErrorMessageType[],
}

export const SHOULD_SHOW_SUCCESS_TOAST = new HttpContextToken<boolean>(() => true);
export const SHOULD_SHOW_ERROR_TOAST = new HttpContextToken<boolean>(() => true);
export const SUCCESS_MESSAGE = new HttpContextToken<string>(() => '');
export const ERROR_MESSAGE = new HttpContextToken<ErrorMessageType[] | undefined>(() =>  undefined);

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  protected readonly apiUrl = environment.apiUrl;
  private readonly http = inject(HttpClient);

  get<T>(endpoint: string, params?: HttpParams, responseType?: any, context?: HttpContext ): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, { params, responseType, context })
      .pipe(catchError(this.handleError));
  }

  getWithURLParams<T>(url: string, responseType?: any, context?: HttpContext): Observable<T> {
    return this.http.get<T>(url, { responseType, context })
    .pipe(catchError(this.handleError));
  }

  post<T>(endpoint: string, body: any, params?: HttpParams, context?: HttpContext): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, body, { params, context  })
      .pipe(catchError(this.handleError));
  }
  
  put<T>(endpoint: string, body: any, params?: HttpParams, context?: HttpContext): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, body, { params, context})
      .pipe(catchError(this.handleError));
  }

  delete<T>(endpoint: string, params?: HttpParams, context?: HttpContext): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, { params, context })
    .pipe(catchError(this.handleError));
  }

  protected patch<T>(endpoint: string, body: any, params?: HttpParams): Observable<T> {
    return this.http.patch<T>(`${this.apiUrl}/${endpoint}`, body, { params })
    .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    // 自定义错误处理
    return throwError(() => new Error(error.message || 'Server error'));
  }
} 